import { Message, Transition } from '@writefull/ui'

import useNotificationsStore from '@infrastructure/stores/notifications/notifications-store'

export default function Notifications() {
  const notifications = useNotificationsStore.use.notifications()
  const hide = useNotificationsStore.use.hide()

  return (
    <div className='fixed top-12 md:top-16 right-6 md:right-8 z-50 flex flex-col items-end gap-2'>
      {notifications.map((notification) => (
        <Transition
          key={notification.id}
          enterFrom='opacity-0 -translate-x-full'
          enterTo='opacity-100 translate-x-0'
          leaveTo='opacity-0 -translate-x-full'
          show
        >
          <Message
            className='min-w-72 max-w-96'
            level={notification.level}
            heading={notification.title}
            body={notification.message}
            duration={10_000}
            cta={notification.cta}
            secondaryCta={notification.secondaryCta}
            onClose={() => hide(notification.id)}
          />
        </Transition>
      ))}
    </div>
  )
}
